import NewNotification from './NewNotification';

export default NewNotification;
